import React from 'react';
import Grid from '../../common/Grid/Grid';
import AssignmentCardItem from './AssignmentCardItem';

/**
 * AssignmentGrid - Virtualized grid for displaying individual assignment cards
 * Uses the shared Grid component with react-window for performance
 */
const AssignmentGrid = ({
  assignments,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  // Action handlers
  onView,
  onViewReport,
  onEditReviewers,
  onDelete,
  onPublish,
  ability,
  hasFiltersApplied,
}) => {
  const renderAssignmentItem = ({ item }) => {
    return (
      <AssignmentCardItem
        assignment={item}
        onView={onView}
        onViewReport={onViewReport}
        onEditReviewers={onEditReviewers}
        onDelete={onDelete}
        onPublish={onPublish}
        ability={ability}
      />
    );
  };

  // Dynamic empty state description based on filters
  const emptyStateDescription = hasFiltersApplied
    ? "No assignments match your filter criteria. Try adjusting your filters."
    : "No individual assignments have been scheduled yet. Click 'Schedule Individual Assignment' to create one.";

  return (
    <Grid
      items={assignments}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderAssignmentItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No Individual Assignments Found"
      emptyStateDescription={emptyStateDescription}
      endOfListMessage="You've reached the end of the list"
      rowHeight={620}
    />
  );
};

export default AssignmentGrid;
